<template>
  <div class="pg-criteria-form-basic">
    <PgOperationTip
      v-if="formItems1.items.length > 0"
      ref="tipRef"
      storageKey="pg-criteria-tip"
    ></PgOperationTip>
    <PgForm
      ref="criteriaFormRef1"
      :model="model"
      :formItems="formItems1"
      @keyup.enter.native="onEnter"
      :dragHandle="dragHandle"
      dataType="formItems1"
      :dragUpdateMethod="dragUpdateMethod"
      :dragRemoveMethod="dragRemoveMethod"
    >
    </PgForm>
    <CollapseTransition :second="0.3">
      <PgForm
        v-if="collapse"
        @keyup.enter.native="onEnter"
        ref="criteriaFormRef2"
        :model="model"
        :formItems="formItems2"
        :dragHandle="dragHandle"
        dataType="formItems2"
        :dragUpdateMethod="dragUpdateMethod"
        :dragRemoveMethod="dragRemoveMethod"
      >
      </PgForm>
    </CollapseTransition>
  </div>
</template>
<script setup>
import { ref, computed, onMounted } from 'vue'
import { Loading } from 'element-ui'
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
import { PgForm } from '../../form/index'
import { PgOperationTip } from '../../operation-tip/index'
import { pgMessage } from '../../message/index'
import { CRITERIFORMCOLUM } from '../hook/use-common-param'
import { post } from '../../../utils/index'

const props = defineProps({
  model: Object,
  formItems: {
    type: [Array, Object],
    default: null,
  },
  collapse: Boolean,
  //为true时，不支持展开收起操作
  showAll: Boolean,
})

const emit = defineEmits(['on-enter'])
const onEnter = () => {
  emit('on-enter')
}

//高级查询必须满足允许自定义&&业务系统有值&&所属功能有值才能进行用户自定义
const dragHandle = computed(() => {
  if (Array.isArray(props.formItems)) {
    return ''
  }
  return props.formItems.criteria?.customize &&
    props.formItems.criteria?.function?.id &&
    props.formItems.criteria?.system?.id
    ? '.pg-form-item-label__drag'
    : ''
})

const visibleItems = computed(() => props.formItems?.items?.filter((im) => im.visible) ?? [])
const formItems1 = computed(() => {
  if (props.showAll) {
    return props.formItems
  }
  return Object.assign({}, props.formItems, {
    items: visibleItems.value.slice(0, CRITERIFORMCOLUM),
  })
})

const formItems2 = computed(() => {
  return Object.assign({}, props.formItems, {
    items: visibleItems.value.slice(CRITERIFORMCOLUM),
  })
})

//保存查询条件
const saveCriter = async (formItems) => {
  const loadingInstance = Loading.service({ background: 'rgba(0,0,0,0)', fullscreen: true })
  const [res] = await post('rest/ezcomp/dict/criteria/saveCriteria', {
    criteria: { code: formItems.code },
    items: formItems.items,
  })
  loadingInstance?.close()
  if (res) {
    pgMessage.success('保存成功')
  }
}
const dragUpdateMethod = (param) => {
  const fromIndex = props.formItems.items.findIndex((im) => im.code === param.fromItemField)
  const toIndex = props.formItems.items.findIndex((im) => im.code === param.toItemField)
  const fromItem = props.formItems.items[fromIndex]
  props.formItems.items.splice(fromIndex, 1)
  props.formItems.items.splice(toIndex, 0, fromItem)
  saveCriter(props.formItems)
}
const dragRemoveMethod = (param, event) => {
  dragUpdateMethod(param)
  const fromDataType = event.from.getAttribute('data-type')
  const toDataType = event.to.getAttribute('data-type')
  if (fromDataType !== toDataType) {
    if (toDataType === 'formItems1') {
      //如果是添加在最后一位则将原来的最后一位移动from节点下，否则将最后一位移动from节点
      const appendIndex =
        event.to.children[event.to.children.length - 1].getAttribute('data-type') ===
        event.item.getAttribute('data-type')
          ? event.to.children.length - 2
          : event.to.children.length - 1
      const tempItem = event.to.children[appendIndex]
      event.from.insertBefore(tempItem, event.from.children[0])
    } else {
      //如果是添加在最后一位则将原来的最后一位移动from节点下，否则将最后一位移动from节点
      const appendIndex =
        event.to.children[0].getAttribute('data-type') === event.item.getAttribute('data-type')
          ? 1
          : 0
      const tempItem = event.to.children[appendIndex]
      event.from.appendChild(tempItem)
    }
  }
}

const criteriaFormRef1 = ref(null) // 第一行  CRITERIFORMCOLUM 个
const criteriaFormRef2 = ref(null) // 第二行 props.formItems?.items?.length - CRITERIFORMCOLUM 个
const validate = async () => {
  const res1 = await criteriaFormRef1.value.validate()
  const res2 = criteriaFormRef2.value ? await criteriaFormRef2.value.validate() : null
  return res1 || res2
}

const tipRef = ref(null)
onMounted(() => {
  if (tipRef.value) {
    tipRef.value.setPosition(criteriaFormRef1.value.$el)
  }
})

defineExpose({
  validate,
})
</script>
<style lang="scss">
@import '../style/criteria-form-basic.scss';
</style>
